import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "max-w-176 w-full justify-between items-center gap-2.5 inline-flex" }
const _hoisted_3 = { class: "self-stretch justify-between items-end inline-flex" }

import { onMounted, ref, onUnmounted, computed, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'StickyFooter',
  props: {
    theme: {},
    id: {},
    anchorQuerySelector: {},
    outsideFormStep: { type: Boolean },
    hideDefaultButtons: { type: Boolean }
  },
  setup(__props: any) {

const resizeObserver = ref<ResizeObserver>();
const screenHeight = ref(window.innerHeight);
const isHidden = ref(true);

const props = __props;

const themeClass = computed(() =>
  props.theme == 'light' ? 'bg-white text-racq-dark-greys' : 'bg-racq-navy text-white'
);

onMounted(() => {
  // Move to body level
  if (props.outsideFormStep) {
    const footerEl = document.getElementById(props.id ?? 'jss-form-sticky-footer');
    footerEl && document.body.appendChild(footerEl);
  }

  // Subscribe to window size change
  resizeObserver.value = new ResizeObserver((entries) => {
    screenHeight.value = entries?.[0]?.contentRect?.height || window.innerHeight;
  });

  resizeObserver.value.observe(document.body);

  // Check anchor element
  if (props.anchorQuerySelector) {
    document.addEventListener('scroll', onScroll);
  }
});

onUnmounted(() => {
  resizeObserver.value?.unobserve(document.body);
  document.removeEventListener('scroll', onScroll);
});

watch(isHidden, (newValue) => {
  hideFooter(newValue);
});

const onScroll = () => {
  const anchorEl = document.querySelector(props.anchorQuerySelector!);
  const footerEl = document.getElementById(props.id ?? 'jss-form-sticky-footer');
  if (!anchorEl || !footerEl) return;
  const shouldHide = anchorEl?.getBoundingClientRect().top < footerEl?.getBoundingClientRect().top;
  if (shouldHide != isHidden.value) isHidden.value = shouldHide;
};

function hideFooter(hide: boolean) {
  const footerEl = document.getElementById(props.id ?? 'jss-form-sticky-footer');
  if (!footerEl) return;
  footerEl.style.height = hide ? '0px' : '';
  footerEl.style.padding = hide ? '0px' : '';
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id ?? 'jss-form-sticky-footer',
    class: _normalizeClass(`flex justify-center h-16 md:h-[68px] w-full left-0 bottom-0 p-3 md:py-3.5 z-[110] transition-all overflow-hidden ${themeClass.value} ${_ctx.outsideFormStep ? 'fixed' : 'sticky'}`)
  }, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "start", {}, () => [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.hideDefaultButtons)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "button",
                inputClass: "btn btn-md btn-secondary",
                label: "[Slot = start]"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _renderSlot(_ctx.$slots, "end", {}, () => [
        (!_ctx.hideDefaultButtons)
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "button",
              inputClass: "btn btn-md btn-primary",
              label: "[Slot = end]"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 10, _hoisted_1))
}
}

})